import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/service"
import { Apply1Response } from "../../api/types/apply"

type initialState = {
    response: Apply1Response | null
}

const applySlice = createSlice({
    name: "apply1",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.apply.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default applySlice.reducer




